import React from 'react';
import { motion } from 'framer-motion';
import { Printer, Package, BookOpen } from 'lucide-react';
import './AboutSection.css';

const AboutSection = () => {
  const features = [
    {
      icon: <Printer size={32} />,
      title: 'Precision Printing',
      description: 'High-quality, vibrant prints for custom cardboard packaging and promotional materials.',
    },
    {
      icon: <Package size={32} />,
      title: 'Custom Packaging',
      description: 'Tailored cardboard solutions to protect and showcase your products.',
    },
    {
      icon: <BookOpen size={32} />,
      title: 'Expert Binding',
      description: 'Professional binding for booklets, folders, and presentations.',
    },
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <motion.div
          className="about-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <h2 className="about-heading">About NIRUPRINT SOLUTIONS</h2>
          <p className="about-subheading">Your partner in premium cardboard printing and binding.</p>
        </motion.div>
        <motion.p
          className="about-description"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          NIRUPRINT SOLUTIONS, based at UNIT H2C, Deseronto Estate, St. Mary Road, Slough, Berkshire, SL3 7EW, specializes in custom cardboard printing and binding services. We empower businesses with high-quality, bespoke solutions for packaging, promotional materials, and professional documents. Contact us at <a href="mailto:nirupal92@gmail.com">nirupal92@gmail.com</a> or <a href="tel:+447304083286">07304 083286</a> to elevate your brand!
        </motion.p>
        <div className="about-features">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)' }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>
        <motion.a
          href="#contact"
          className="about-cta"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          viewport={{ once: true }}
        >
          Get Started
        </motion.a>
      </div>
    </section>
  );
};

export default AboutSection;